<app-dialog 
  [title]="data.title" 
  [actions]="[
      { text: 'Cancel', buttonStyle: 'underline' },
      {
        text: data.title == 'Assign Tags' ?  'Save' : 'Remove',
        isDisabled: ((data.page == 'shipyard' || data.page=='replenish' ) ? !selectedSKU.length :  !selectedItems.length ) || !selectTags.length ,
        spin: spin
      }
    ]" 
  (action)="action($event)" 
  (close)="close()"
>
  <div>
    <div class="mt-4">
      <label class="input-container_label">Select Tags</label>
      <div class="indicator-tags">
        <span class="indicator-tags_tags" *ngFor="let tag of selectTags" [style.backgroundColor]="tag?.colorCode">
          {{ tag.name }}
          <span class="tagDelete" (click)="removeTag(tag.tagId)">
            <i class="fal fa-times-circle"></i>
          </span>
        </span>
        <span class="indicator-tags_addTags" [matMenuTriggerFor]="indicatorTags" (click)="isShowTags = true">
          <i class="fal fa-plus hand"></i>
        </span>
      </div>
    </div>


    <mat-menu #indicatorTags="matMenu" xPosition="after">
      <div class="indicator-tags d-flex flex-column align-items-start p-3" *ngIf="allTags.length && isShowTags">
        <span class="indicator-tags_tags" *ngFor="let tag of allTags" [style.backgroundColor]="tag?.colorCode"
          (click)="selectTag(tag)">
          {{ tag.name }}
        </span>
      </div>
      <div class="tags-not-found" *ngIf="!allTags.length">
        <span> No Tags </span>
      </div>
    </mat-menu>
  </div>

  <div>
    <div [formGroup]="form" *ngIf="!importBulk">
      <app-page-container-devider [title]="'Assign to a product or listings'" [small]="true" class="my-4 small text-dark"></app-page-container-devider>
      <div class="add-sku_form">
        <div class="input-container input-container--flex">
          <div class="d-flex justify-content-between align-items-center">
            <label for="" class="input-container_label mb-1">{{ (data.page == 'shipyard'  || data.page=='replenish')? "Search SKUs" : "Search Items" }}
            </label>

            <div>

              <app-button [buttonStyle]="'text underline'" [buttonSize]="'action'" [buttonColor]="'primary'"
                (click)="importBulk = true">Import Bulk</app-button>
            </div>
          </div>

          <input id="skuAutocomplete" type="text" class="input-container_input input-container_input--thin"
            formControlName="skuAutocomplete" [matAutocomplete]="auto" (paste)="onPaste($event)" />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
            <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option" class="mat-option-override">
              <app-item-typeahead [name]="option.title" [id]="option.name" [sku]="option.sku" [asin]="option.asin"
                [image]="option.imageUrl" [condition]="option.condition"></app-item-typeahead>
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="add-sku_button">
          <button class="button" (click)="verifyAndLoadSku()"
            [ngClass]="{'disabled' : !form.get('skuAutocomplete').value }">
            Confirm
          </button>
        </div>
      </div>
    </div>

    <mat-dialog-content >

  
      <div class="add-sku_list add-sku-list-number">
     <div *ngIf="selectedSKU.length && (this.data.page == 'shipyard' || data.page =='replenish' )">
      <app-shipment-sku [box]="true" [sku]="sku" [skuRemove]="true" [isAssignSku]="true"  (removeSkuEvent)="removeSku(sku)"
      *ngFor="let sku of selectedSKU"></app-shipment-sku>
     </div>

     <div *ngIf="selectedItems.length && this.data.page == 'products'">
      <app-shipment-sku [box]="true" [vendorItem]="true" [sku]="item" [skuRemove]="true"
      (removeSkuEvent)="removeSku(item)" *ngFor="let item of selectedItems"></app-shipment-sku>
     </div>
      </div>
    </mat-dialog-content>
  </div>

  <div class="add-sku_list">
  </div>

  <div *ngIf="importBulk && !validatedSku">
    <form [formGroup]="importBulkForm">
      <div class="input-container w-100">
        <div class="d-flex justify-content-between mt-3">
          <label class="input-container_label ">Paste Bulk</label>
          <app-button [buttonStyle]="'text'" [buttonSize]="'action'" [buttonColor]="'primary'" (click)="importBulk = false">
            Back</app-button>
        </div>
        <textarea class="input-container_input" rows="10" formControlName="skuList"
          placeholder="{{ (data.page == 'shipyard' || data.page =='replenish' ) ? 'SKU - Tab delimited' :  'Item - Tab delimited'}}"></textarea>
      </div>
      <div class="text-center add-sku_importbulk-btn">
        <app-button [buttonSize]="'action'" [spin]="validatorSpin" (click)="validateSkus()"
          [isDisabled]="importBulkForm.invalid">Validate</app-button>
      </div>
    </form>
  </div>

  <div class="errors" *ngIf="invalidSkus.length">
    <div class="errors_item">
      <div class="errors_reason">
        <span>The following {{ invalidSkus.length }} {{ (data.page == 'shipyard' || data.page =='replenish' ) ? 'SKU(s)' : 'Item(s)' }}are invalid.</span><br />
        {{ invalidSkus.toString() }}
      </div>
    </div>
  </div>

</app-dialog>